/**
 * Created by samuel on 10.03.2017.
 */

export class Building {
  public acml: string;
  public longitude: string;
  public latitude: string;

  constructor(obj: any) {
    this.acml = obj.acml ? obj.acml : '';
    this.longitude = obj.longitude ? obj.longitude : '';
    this.latitude = obj.latitude ? obj.latitude : '';
  }

  public AsObject(): any {
    return {
      acml: this.acml,
      longitude: this.longitude,
      latitude: this.latitude,
    };
  }
}
